import { z } from 'zod';
import { TargetPopulationSchema } from './target-population.entity';

export const CreateTargetPopulationDtoSchema = TargetPopulationSchema.omit({
  id: true,
});

export const UpdateTargetPopulationDtoSchema = TargetPopulationSchema.partial({
  id: true,
});

export type CreateTargetPopulationDto = z.infer<
  typeof CreateTargetPopulationDtoSchema
>;

export type UpdateTargetPopulationDto = z.infer<
  typeof UpdateTargetPopulationDtoSchema
>;

export const GetTargetPopulationDtoSchema = TargetPopulationSchema;

export type GetTargetPopulationDto = z.infer<
  typeof GetTargetPopulationDtoSchema
>;
